module.exports = __webpack_public_path__ + "img/pic_4_zh.c3390f2d.png";